import { render, staticRenderFns } from "./ResetPasswordReseller.vue?vue&type=template&id=f5f37ba4&"
import script from "./ResetPasswordReseller.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordReseller.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordReseller.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports